import React from 'react';
import { Message } from 'semantic-ui-react';

export default () => (
  <Message
    size="large"
    icon="hourglass half"
    header="Work in Progress"
    content="This page is not ready yet, check back later 😉"
  />
);
